export default "__VITE_ASSET__f6e07a03__"